import React, { Component } from 'react';
import {
  Button,
  Modal,
  Row,
  Col,
  Label,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import _ from "underscore";

const RemoveStopModal = (props) => {
  const { t } = useTranslation();
  return (
    <Modal show={props.show} bsSize="sm" enforceFocus={false}>
      <Modal.Header >
        <Modal.Title>{t('REMOVE_STOP_FROM_SHIPMENT')}?</Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <Row>
          <Col xs={5}></Col>
          <Col xs={7}>
            <div className="flex flex-row">
              <button
                className="button button-green hover:bg-green-dark text-white mr-2"
                onClick={() => {
                  props.removeStop();
                  props.onClose();
                }}
              >
                {t('CONFIRM')}
              </button>
              <button
                className="button bg-white text-grey hover:text-grey-darker"
                onClick={() => {
                  props.onClose();
                }}
              >
                {t('CANCEL')}
              </button>
            </div>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default RemoveStopModal;
